<template>
  <VSnapNav
    v-if="currentHref"
    ref="snapNav"
    v-model="currentHref"
    class="first-navs"
    inkbar
    :force-bar-width="16"
    bar-height="4px"
  >
    <template v-for="(item, index) in firstNavs">
      <VSnapNavItem
        :key="item.href"
        :name="item.href"
        class="first-nav-wrap"
      >
        <FirstNavItem
          :item="item"
          :order="index + 1"
          :active="currentHref === item.href"
          :loaded-all-img="loadedAllImg"
          @on-load-img="onLoadImg"
        />
      </VSnapNavItem>
    </template>
  </VSnapNav>
</template>

<script>
import VSnapNav from 'fe-vui/snapNav'
import VSnapNavItem from 'fe-vui/snapNavItem'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@ms/stores/auth'
import { useLayoutStore } from 'wap/stores/layout'
import FirstNavItem from './FirstNavItem'

export default {
  name: 'FirstNavs',
  components: {
    VSnapNav,
    VSnapNavItem,
    FirstNavItem
  },
  setup() {
    const auth = useAuthStore()
    const { loginStatus } = storeToRefs(auth)
    const layoutStore = useLayoutStore()
    const { firstNavs } = storeToRefs(layoutStore)
    const { fetchFirstNavs } = layoutStore
    return {
      loginStatus,
      firstNavs,
      fetchFirstNavs
    }
  },
  data() {
    return {
      currentHref: '',
      loadedImgCount: 0
    }
  },
  computed: {
    totalImgNav() {
      return this.firstNavs.filter((x) => x.image).length
    },
    loadedAllImg() {
      return this.loadedImgCount === this.totalImgNav
    }
  },
  watch: {
    firstNavs(val) {
      this.resolveList(val)
      this.listenRouteChange(val)
    },
    loginStatus(val) {
      // 首页一级导航在登录后有更新请求
      if (val && this.$route.meta.showNewTag && this.$route.name !== 'home') {
        this.fetchFirstNavs()
      }
    }
  },
  created() {
    if (this.firstNavs.length) {
      this.resolveList(this.firstNavs)
      this.listenRouteChange(this.firstNavs)
    }
    if (this.$route.name !== 'home') {
      this.fetchFirstNavs()
    }
  },
  methods: {
    onLoadImg() {
      this.loadedImgCount++
      this.$refs.snapNav.updateBar()
      const elActive = this.$refs.snapNav.$el.querySelector('.first-nav-wrap.active')
      if (elActive) {
        if (elActive.scrollIntoViewIfNeeded) {
          elActive.scrollIntoViewIfNeeded()
        } else {
          elActive.scrollIntoView()
        }
      }
    },
    resolveList(navlist) {
      for (let i = 0; i < navlist.length; i++) {
        const { href, name } = navlist[i]
        if (this.checkActive(href, name)) {
          this.currentHref = href
          break
        }
      }

      if (!this.currentHref) {
        this.currentHref = navlist[0].href
      }
    },
    regUrl(href, pathname = location.pathname) {
      const matchedArr = pathname.match(/\/(\w*)\/*$/)
      if (!matchedArr) return false
      const pagename = pathname.match(/\/(\w*)\/*$/)[1]
      if (pagename === this.$region) {
        // home
        return true
      }
      const reg = new RegExp(pagename, 'i')
      const temp = href.match(/\/(\w*)\/*$/) || href.match(/\/(\w*)\?/)
      if (!temp) return false
      const target = temp[1]
      return target ? reg.test(target) : false
    },
    checkActive(href, name) {
      // 开发环境匹配
      if (process.env.NODE_ENV === 'development') {
        const status = location.href.indexOf(name) !== -1
        if (location.pathname === '/') {
          const pathname = this.$route ? this.$route.path : location.pathname
          return this.regUrl(href, pathname)
        }
        return status
      }
      return this.regUrl(href)
    },
    listenRouteChange(navlist) {
      if (this.$route) {
        this.$watch(
          () => this.$route,
          () => {
            this.resolveList(navlist)
          }
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.first-navs {
  position: relative;
  user-select: none;

  ::v-deep {
    .snap-ink-bar {
      bottom: 8px;
      background: #ffca27;
    }

    .snap-nav {
      .first-nav-wrap {
        padding: 0 8px;

        &:first-child {
          margin-left: 12px;
        }

        &:nth-last-child(2) {
          margin-right: 12px;
        }
      }
    }
  }

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 90%;
    background: linear-gradient(270deg, #2C1924 32%, rgba(46,25,38,0%) 100%) no-repeat;
    content: "";
  }
}

[data-mode="light"] .first-navs {
  &::after {
    width: 36px;
    background: linear-gradient(to left, #F8F8F8 50%, rgba(248,248,248,0%) 100%) no-repeat;
  }
}
</style>
